(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["makai-seasonal-effects"]) return;
  try {
    
(() => {
  let cleanup = () => {};
  function start() {
    cleanup();
    const config = document.getElementById('makai-seasonal-effects');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const small = window.matchMedia('(max-width: 767px)').matches;
    if (!config || reduced || (small && config.dataset.mobile !== 'true') || (config.dataset.homeOnly === 'true' && config.dataset.isHome !== 'true')) return;
    const layer = document.createElement('div');
    layer.className = 'makai-seasonal-layer';
    layer.setAttribute('aria-hidden', 'true');
    const button = document.createElement('button');
    button.className = 'makai-seasonal-toggle';
    button.type = 'button';
    button.textContent = config.dataset.pauseLabel;
    button.setAttribute('aria-pressed', 'false');
    const paths = {
      halloween: '<path d="M1 14Q5 3 12 9L14 3 18 10Q20 6 22 10L26 3 28 9Q35 3 39 14L29 12 24 19 20 16 16 19 11 12Z"/>',
      christmas: '<path d="M19 1h2v12l8-8 2 2-9 10h13v3H22l9 10-2 2-8-9v12h-2V23l-9 9-2-2 9-10H4v-3h13L8 7l2-2 9 8Z"/>',
      black_friday: '<path d="M4 4h19l13 13-19 19L4 23Z"/><circle cx="13" cy="13" r="3" fill="#fffaf3"/>'
    };
    const count = small ? 3 : config.dataset.intensity === 'medium' ? 10 : 6;
    for (let i = 0; i < count; i++) {
      const particle = document.createElement('span');
      particle.className = 'makai-seasonal-particle';
      particle.style.setProperty('--x', `${5 + (i * 89 / count)}%`);
      particle.style.setProperty('--delay', `${i * 0.35}s`);
      particle.innerHTML = `<svg viewBox="0 0 40 40" aria-hidden="true">${paths[config.dataset.season] || paths.halloween}</svg>`;
      layer.append(particle);
    }
    document.body.append(layer, button);
    const hide = () => { layer.hidden = true; button.hidden = true; };
    let timer;
    function stopTimer() { window.clearTimeout(timer); }
    function planEnd() { stopTimer(); timer = window.setTimeout(hide, 16500); }
    button.addEventListener('click', () => {
      const paused = layer.classList.toggle('is-paused');
      button.textContent = paused ? config.dataset.resumeLabel : config.dataset.pauseLabel;
      button.setAttribute('aria-pressed', String(paused));
      if (paused) stopTimer(); else planEnd();
    });
    const onVisibility = () => { if (document.hidden) layer.classList.add('is-paused'); else if(button.getAttribute('aria-pressed') !== 'true') layer.classList.remove('is-paused'); };
    document.addEventListener('visibilitychange', onVisibility);
    planEnd();
    cleanup = () => { stopTimer(); layer.remove(); button.remove(); document.removeEventListener('visibilitychange', onVisibility); };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true }); else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();
})();
